import { render, staticRenderFns } from "./BankDrawer.vue?vue&type=template&id=0fe16174&"
import script from "./BankDrawer.vue?vue&type=script&lang=ts&"
export * from "./BankDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports